import Alpine from 'alpinejs';

export default Alpine.data('siteNav', () => ({
    menuIsOpen: false,
    isAnimating: false,
    isMobile:  window.outerWidth > 1024 ? false : true,
    body: {
        ['@keydown.escape']() {
            this.menuIsOpen = false;
        },
        ['@resize.window.debounce']() {
            if(window.outerWidth > 1024) {

                this.isMobile = false;

                if(this.menuIsOpen) {
                    this.menuIsOpen = false;
                }

            } else {

                this.isMobile = true;
                
            }
        },
        [':class']() {
            return {
                'overflow-hidden nav-is-open': this.menuIsOpen
            }
        }
    },
    mainNavigationContainer: {
    },
    mainNavigation: {
        ['x-transition:enter']: 'transition duration-200',
        ['x-transition:enter-start']: 'mobile-nav-max:-translate-x-full opacity-0',
        ['x-transition:enter-end']: 'mobile-nav-max:translate-x-0 opacity-100',
        ['x-transition:leave']: 'transition duration-200',
        ['x-transition:leave-start']: 'mobile-nav-max:translate-x-0 opacity-100',
        ['x-transition:leave-end']: 'mobile-nav-max:-translate-x-full opacity-0',
        ['x-show']() {
            return this.menuIsOpen;
        }
    },
    mainNavigationBackdrop: {
        ['@click']() {
            this.menuIsOpen = false;
        }
    },
    hamburger: {
        ['@click']() {
            this.menuIsOpen = !this.menuIsOpen;
        },
    }
}));